import React, { useEffect } from 'react'
import { Stack, Text } from 'rsuite'
import DoingRoundIcon from '@rsuite/icons/DoingRound'
import InfoRoundIcon from '@rsuite/icons/InfoRound'
import RemindFillIcon from '@rsuite/icons/RemindFill'
import CheckRoundIcon from '@rsuite/icons/CheckRound'
import RemindRoundIcon from '@rsuite/icons/RemindRound'

const validTypes = ['loading', 'info', 'warning', 'danger', 'success']

const IconIndicator = ({
    type = 'loading',
    isAnimated = true,
    size = 24,
    color = '#ABABAB',
    text = '',
    isVertical = true,
    textStyle = { marginLeft: 8 },
    customIcon,
    ...rest
}) => {
    useEffect(() => {
        const prevStyle = getComputedStyle(
            document.documentElement
        ).getPropertyValue('--rs-primary-600')
        document.documentElement.style.setProperty(
            '--rs-primary-600',
            '#FF0000'
        )

        // On unmount
        return () => {
            document.documentElement.style.setProperty(
                '--rs-primary-600',
                prevStyle
            )
        }
    }, [])

    const getTypeIcon = () => {
        let iconType = validTypes.includes(type) ? type : 'loading'
        let selectedIcon = (
            <DoingRoundIcon
                spin={true}
                color={color}
                style={{
                    fontSize: size,
                }}
            />
        )
        switch (iconType) {
            default:
            case 'loading':
                break
            case 'info':
                selectedIcon = (
                    <InfoRoundIcon
                        spin={isAnimated}
                        color={color}
                        style={{
                            fontSize: size,
                        }}
                    />
                )
                break
            case 'warning':
                selectedIcon = (
                    <RemindRoundIcon
                        spin={isAnimated}
                        color={color}
                        style={{
                            fontSize: size,
                        }}
                    />
                )
                break
            case 'danger':
                selectedIcon = (
                    <RemindFillIcon
                        spin={isAnimated}
                        color={color}
                        style={{
                            fontSize: size,
                        }}
                    />
                )
                break
            case 'success':
                selectedIcon = (
                    <CheckRoundIcon
                        spin={isAnimated}
                        color={color}
                        style={{
                            fontSize: size,
                        }}
                    />
                )
                break
        }
        return selectedIcon
    }

    return (
        <Stack
            {...rest}
            direction={isVertical ? 'column' : 'row'}
            justify="center"
        >
            <Stack.Item>
                {customIcon ? { customIcon } : getTypeIcon()}
            </Stack.Item>
            {text.length > 0 ? (
                <Stack.Item>
                    <Text style={textStyle}>{text}</Text>
                </Stack.Item>
            ) : null}
        </Stack>
    )
}

export default IconIndicator
